let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("X296d")).then(() => parcelRequire('fKjm4'));